import React from "react";
import Swiper from "react-id-swiper";
import { referenceLogos } from "../../data/index";
import { SingleReferenceLogo } from "../../components";

const ReferenceLogos = () => {
  const params = {
    loop: true,
    grabCursor: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
      1024: {
        slidesPerView: 5,
      },
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      480: {
        slidesPerView: 2,
      },
      320: {
        slidesPerView: 1,
      },
    },
  };
  return (
    <div className="dg__brand__area bg__color--3 pt--90">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            {/* section title */}
            <div className="section__title text-center">
              <h2 className="with__line">Our references</h2>
              <p>
                A few of the hundreds of institutions that met us on Turkey's
                leading research platform{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid space-between">
        <div className="row">
          <div className="col-lg-12">
            <div className="brand__inner">
              <ul className="brand__list brand__acivation">
                <Swiper {...params}>
                  {referenceLogos &&
                    referenceLogos.map((single, key) => {
                      return (
                        <SingleReferenceLogo
                          data={single}
                          key={key}
                          sliderClass="swiper-slide"
                        />
                      );
                    })}
                </Swiper>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferenceLogos;
